function imageSize(src) {
  /* eslint-disable */
  var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
  /* esling-enable */

  if (match) {
    return match[1];
  } else {
    return null;
  }
}

function getSizedImageUrl(src, size) {
  if (size === null) {
    return src;
  }

  if (size === 'master') {
    return removeProtocol(src);
  }

  var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);

  if (match) {
    var prefix = src.split(match[0]);
    var suffix = match[0];

    return removeProtocol(prefix[0] + '_' + size + suffix);
  } else {
    return null;
  }
}

const createItem = ({
  product_id,
  variant_id: id,
  product_title: title,
  line_price: price,
  options_with_values,
  image,
  url,
  quantity,
}) => {
  const variantTitle = formatVariant(options_with_values);
  const img = image
    ? getSizedImageUrl(image.replace("." + imageSize(image), ""), "200x")
    : "https://www.placecage.com/200/200"; // todo: replace with different placeholder image

  // View this as cart-item.liquid - basically. -ae 06.22.19
  return `
    <drawer-item class='cart-drawer__item' data-component='cartDrawerItem' data-pid=${product_id} data-id=${id}>
      <a href='${url}' class="cart-drawer__item-image">
        <img src='${img}' />
      </a>

      <div class='cart-item__details f fdc jcb'>
        <div class='cart-item__header'>
          <div class='cart-item__title'>
            <a href='${url}' class='caps mv0 unstyled-link'>${title}</a>
            <div class='xxsmall sans caps cm mt025 book'>${variantTitle}</div>
          </div>
          <span class='dn'>${formatMoney(price)}</span>
          <div class='cart-item__price'>${removeTrailingZeros(
            formatMoney(price)
          )}</div>
        </div>

        <div class='cart-item__tools'>
          <div class='cart-item__stepper aic f ${
            price === 0 ? "is-disabled" : ""
          }'>
            <div class='cart-stepper js-remove-single'>
              <span class='visually-hidden'>Decrease quantity for ${title}</span>
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus cart-stepper--remove" fill="none" viewBox="0 0 10 2">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
              </svg>
            </div>
            <div class='cart-quantity js-single-quantity'>${quantity}</div>
            <div class='cart-stepper js-add-single'>
              <span class='visually-hidden'>Increase quantity for ${title}</span>
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus cart-stepper--add" fill="none" viewBox="0 0 10 10">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
              </svg>
            </div>
          </div>

          <button class='button--reset button--remove js-remove-item'>Remove</button>
        </div>
      </div>
    </drawer-item>
`;
};

function renderItems(items) {
  console.log('items from renderItems', items);

  if (items === undefined) {
    console.log('Can\'t reach cart.js');
    return;
  }
  if (items.length <= 0) return '';

  return items.reduce((accum, item) => (accum += createItem(item)), '');
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.cartDrawerState = {
      open: false,
    };

    this.overlay = this.querySelector('.js-overlay');
    this.closeButton = this.querySelector('.js-close');
    this.subtotal = this.querySelector('.js-subtotal');
    this.currencyCode = this.querySelector('.js-currency-code');
    this.itemsRoot = this.querySelector('.js-cart-drawer-items');
    this.upsellBlock = this.querySelector('upsell-block');
    this.cartDrawer = this.querySelector('.js-cart-drawer');
    this.cartCount = document.querySelectorAll('.js-cart-count');
    this.cartBubble = document.querySelector('.js-cart-bubble');
    this.cartFooter = this.querySelector('.js-cart-footer');
    this.cartEmpty = this.querySelector('.js-cart-empty');
    this.cartEmptyMsg = this.querySelector('.js-empty-message');

    this.cartToggle = document.querySelector('.js-cart-drawer-toggle');

    // this.shippingProgressBar = this.querySelector('.js-shipping-progress-bar');
    // this.shippingProgressMsg = this.querySelector('.js-free-shipping-amount-remaining');
    // this.freeShippingUnmet = this.querySelector('.js-free-shipping-unmet-msg');
    // this.freeShippingMet = this.querySelector('.js-free-shipping-met-msg');
  }

  connectedCallback() {
    // Check initial cart state on load
    fetchCart().then((cart) => {
      if (cart.item_count) {
        this.cartBubble.classList.add("is-active");
      } else {
        this.cartBubble.classList.remove("is-active");
      }
    });
    document.addEventListener('cart:updated', (e) => {
      e.preventDefault();

      fetchCart().then((cart) => {
        this.render(cart);

        this.cartCount.forEach((cartCountEl) => {
          console.log('cart.item_count', cart.item_count);
          console.log('cartCountEl coming from', cartCountEl);
          cartCountEl.innerHTML = cart.item_count;
        });
        this.upsellBlock.updateUpsellItems();

        if (cart.item_count) {
          this.cartBubble.classList.add('is-active');
        } else {
          this.cartBubble.classList.remove('is-active');
        }
      });
    });

    this.cartToggle.addEventListener('click', (e) => {
      e.preventDefault();
      fetchCart().then((cart) => {
        this.open(cart);
        this.setActiveElement(document.activeElement);
      });

      this.cartDrawerState.open = true;
    });

    this.overlay.addEventListener('click', (e) => {
      e.preventDefault();
      this.close();

      this.cartDrawerState.open = false;
    });

    this.closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('clicking close!');
      this.close();

      this.cartDrawerState.open = false;
    });
  }

  render = (cart) => {
    this.itemsRoot.innerHTML = renderItems(cart.items);
    // this is using es2020 nullish coalescing operator and may cause issues on older browsers - ae05.30.22
    this.subtotal.innerHTML = removeTrailingZeros(
      formatMoney(cart.total_price)
    );
    this.currencyCode.innerHTML =
      document.querySelector("meta[property='currency-code']")?.content ?? "";

    console.log(cart.items);

    if (cart.items === undefined) {
      this.cartFooter.classList.add("is-hidden");
      this.itemsRoot.classList.add("is-hidden");
      this.cartEmpty.classList.remove("is-hidden");
      this.cartEmptyMsg.classList.add("is-hidden");
    } else if (cart.items.length === 0) {
      // hide items mount point and cart footer if there are no items in the cart
      this.cartFooter.classList.add("is-hidden");
      this.itemsRoot.classList.add("is-hidden");
      this.cartEmpty.classList.remove("is-hidden");
    } else {
      // unhide items mount point and cart footer if there are items in the cart
      this.cartFooter.classList.remove("is-hidden");
      this.itemsRoot.classList.remove("is-hidden");
      this.cartEmpty.classList.add("is-hidden");
    }
  };

  open = (cart) => {
    if (cart === undefined) {
      const err = `Open requires a Cart object to be passed, cart is currently set to ${cart}`;
      throw new Error(err);
    }

    try {
      hideChatWidget();
    } catch (e) {
      console.log('hideChatWidget function undefined or chat widget not present');
    }

    this.classList.remove('is-hidden');
    this.classList.add('is-active');

    this.itemsRoot.innerHTML = this.loading;



    setTimeout(() => {
      this.classList.add('is-visible');
      this.tabIndex = 0;
      this.cartDrawer.tabIndex = 0;
      this.setAttribute('aria-expanded', 'true');
      document.getElementById('root').tabIndex = -1;
      console.log('cart from inside timeout', cart);
      setTimeout(this.render(cart), 10);
      this.cartDrawerState.open = true;
      // this.upsellBlock?.updateSlider();

      console.log('cart drawer state is', this.cartDrawerState.open);
    }, 50);

    console.log('drawerOpen');
  };

  close = () => {
    this.classList.remove('is-visible');

    try {
      showChatWidget();
    } catch (e) {
      console.log('showChatWidget function undefined or chat widget not present');
    }

    document.getElementById('root').tabIndex = 0;

    setTimeout(() => {
      this.classList.remove('is-active');
      this.classList.add('is-hidden');
      this.tabIndex = -1;
      this.setAttribute('aria-expanded', 'false');
      this.cartDrawerState.open = false;

      console.log('cart drawer state is', this.cartDrawerState.open);
    }, 400);
  };

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class DrawerItem extends HTMLElement {
  constructor() {
    super();
    console.log('drawer-item, yes');

    this.removeButton = this.querySelector('.js-remove-item');
    this.decrease = this.querySelector('.js-remove-single');
    this.increase = this.querySelector('.js-add-single');
    this.currentQty = this.querySelector('.js-single-quantity').innerHTML;
    this.id = this.getAttribute('data-id');
  }

  connectedCallback() {
    this.removeButton.addEventListener('click', (e) => {
      e.preventDefault();
      removeAddon(this.id);
    });

    this.decrease.addEventListener('click', (e) => {
      e.preventDefault();
      updateAddon(this.id, parseInt(this.currentQty) - 1);
    });

    this.increase.addEventListener('click', (e) => {
      e.preventDefault();
      updateAddon(this.id, parseInt(this.currentQty) + 1);
    });
  }
}

customElements.define('drawer-item', DrawerItem);

class UpsellBlock extends HTMLElement {
  constructor() {
    super();
    this.upsellItemsContainer = this.querySelector('.upsell-products-container');
    this.discountableUpsellCards = null;
    this.loadingSpinnerSnippet = `
      <div class="loading-overlay--upsell" style="display: flex; justify-content: center; align-items: center; min-height: 100px;">
        <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" style="width: 30px; height: 30px;" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" stroke="currentColor" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
    `;
  }

  connectedCallback() {
    this.updateUpsellItems();
  }

  updateUpsellItems() {
    if (this.upsellItemsContainer) {
      this.upsellItemsContainer.innerHTML = this.loadingSpinnerSnippet; // Show loader
    } 


    fetch('/cart?view=upsell-items')
      .then(response => {
        console.log('fetch request upsell', response);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const updatedHTML = parser.parseFromString(html, 'text/html');
        const upsellData = updatedHTML.querySelector('.cart-upsell-block').innerHTML;
        this.renderUpsellItems(upsellData);
        this.updateDiscountableUpsellPrices(this.discountableUpsellCards);
      })
      .catch(error => {
        console.error('Error fetching upsell items:', error);
      });
  }

  renderUpsellItems(html) {
    if (this.upsellItemsContainer) {
      this.upsellItemsContainer.innerHTML = html;
      this.discountableUpsellCards = this.upsellItemsContainer.querySelectorAll('product-card-small[data-upsell-discount-product="true"]');
    } else {
      console.error('Upsell items container not found');
    }
  }

  updateSlider() {
    // Delay execution slightly to ensure it's visible & rendered
    setTimeout(() => {
      const upsellProductsEl = this.querySelector('upsell-products');
      if (upsellProductsEl && typeof upsellProductsEl.thumbnailSlider?.update === 'function') {
        upsellProductsEl.thumbnailSlider.update(); // Re-initialize Keen if already mounted
      } else if (upsellProductsEl && !upsellProductsEl.thumbnailSlider) {
        // Manually trigger connectedCallback again if necessary
        upsellProductsEl.connectedCallback?.();
      } else {
        console.warn('Upsell products slider not ready or not found');
      }
      console.log('inside updateslider function', upsellProductsEl,  typeof upsellProductsEl.thumbnailSlider)
    }, 100); // Adjust timeout as needed
  }

  updateDiscountableUpsellPrices() {
    if (!this.discountableUpsellCards || this.discountableUpsellCards.length === 0) {
      // console.log('No discountable upsell product cards found to update prices.');
      return;
    }

    this.discountableUpsellCards.forEach(cardElement => {
      const priceContainer = cardElement.querySelector('.upsell-burr-price');
      if (!priceContainer) return;

      const originalLocalizedPriceCents = parseInt(priceContainer.dataset.originalLocalizedPriceCents, 10);
      // This is the discount in USD_CENTS (e.g., 10000 for $100, 15000 for $150)
      const activeUsdDiscountInUsdCents = parseInt(priceContainer.dataset.activeUsdDiscountCents, 10);

      const originalPriceDisplayEl = priceContainer.querySelector('.original-price-display');
      const discountedPriceDisplayEl = priceContainer.querySelector('.discounted-price-display');
      const discountMessageEl = priceContainer.nextElementSibling; // Assuming it's the direct next sibling

      const moneyFormat = window.moneyFormat || "{{amount}}"; // From theme.liquid
      const shopifyCurrencyRate = parseFloat(Shopify.currency.rate); // Rate: Primary Shop Currency to Current Display Currency

      if (isNaN(originalLocalizedPriceCents) || isNaN(activeUsdDiscountInUsdCents)) {
          console.error('Price or discount data is invalid for EG1 Burrs upsell.');
          originalPriceDisplayEl.style.display = 'none';
          discountedPriceDisplayEl.innerHTML = customFormatMoney(originalLocalizedPriceCents || 0, moneyFormat);
          if (discountMessageEl && discountMessageEl.classList.contains('discount-message')) discountMessageEl.style.display = 'none';
          return;
      }

      if (activeUsdDiscountInUsdCents > 0 && !isNaN(shopifyCurrencyRate) && shopifyCurrencyRate > 0) {

          let localizedDiscountAmountCents;
          if (window.shopPrimaryCurrency === 'USD') { // window.shopPrimaryCurrency = {{shop.currency | json}}
              localizedDiscountAmountCents = Math.round((activeUsdDiscountInUsdCents / 100) * shopifyCurrencyRate * 100);
          } else {
              console.warn("Shopify.currency.rate is from shop primary to display. If shop primary is not USD, this discount conversion is an approximation.");
              localizedDiscountAmountCents = Math.round((activeUsdDiscountInUsdCents / 100) * shopifyCurrencyRate * 100);
          }


          const calculatedDiscountedLocalizedPriceCents = originalLocalizedPriceCents - localizedDiscountAmountCents;

          // Ensure discounted price is not negative
          const finalDisplayPriceCents = Math.max(0, calculatedDiscountedLocalizedPriceCents);

          originalPriceDisplayEl.innerHTML = `<s>${customFormatMoney(originalLocalizedPriceCents, moneyFormat)}</s>`;
          discountedPriceDisplayEl.innerHTML = customFormatMoney(finalDisplayPriceCents, moneyFormat);
          originalPriceDisplayEl.style.display = 'inline';

          if (discountMessageEl && discountMessageEl.classList.contains('discount-message')) {
              discountMessageEl.style.display = 'block';
          }
          // console.log('JPY Example: Original Local Cents:', originalLocalizedPriceCents, 'USD Discount Cents:', activeUsdDiscountInUsdCents, 'Rate:', shopifyCurrencyRate, 'Localized Discount Cents:', localizedDiscountAmountCents, 'Final Display Cents:', finalDisplayPriceCents);

      } else {
          originalPriceDisplayEl.style.display = 'none';
          discountedPriceDisplayEl.innerHTML = customFormatMoney(originalLocalizedPriceCents, moneyFormat);
          if (discountMessageEl && discountMessageEl.classList.contains('discount-message')) {
              discountMessageEl.style.display = 'none';
          }
      }
    });
  }

}

customElements.define('upsell-block', UpsellBlock);